module.exports = __webpack_public_path__ + "images/blog/blog_balloon/man_4d27e246b394bee29b5fe3827fd61474.png";